import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31aacbf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "dialogChild",
  class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, " ​ ", -1))
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" }
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_5 = { class: "sm:flex sm:items-start" }
const _hoisted_6 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" }
const _hoisted_7 = {
  class: "mt-2 text-sm text-gray-700",
  "data-test-confirm-content": ""
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "bg-gray-100 px-4 py-3 sm:px-6 sm:space-x-3 space-y-3 sm:space-y-0 flex flex-col sm:flex-row sm:justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_AppDynamicIcon = _resolveComponent("AppDynamicIcon")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_HeadlessUiDialog = _resolveComponent("HeadlessUiDialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.isOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_component_HeadlessUiDialog, {
        as: "div",
        class: "fixed z-50 inset-0 overflow-y-auto",
        "initial-focus": _ctx.$refs.dialogChild,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.preventBackdropClose ? _ctx.close(false) : undefined))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-700 bg-opacity-70 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.iconWrapperClasses, "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10"])
                      }, [
                        _createVNode(_component_AppDynamicIcon, {
                          icon: _ctx.dynamicIconProperties,
                          "extended-dom-classes": _ctx.iconDomClasses,
                          class: "h-4 w-4"
                        }, null, 8, ["icon", "extended-dom-classes"])
                      ], 2),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_DialogTitle, {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.title), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_7, [
                          (_ctx.html)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "confirm-html-content",
                                innerHTML: _ctx.content
                              }, null, 8, _hoisted_8))
                            : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.content), 1))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_AppButton, {
                      type: "secondary",
                      disabled: _ctx.confirmLoading || _ctx.cancelLoading,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close(false)))
                    }, _createSlots({
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.cancelButtonContent), 1)
                      ]),
                      _: 2
                    }, [
                      (_ctx.cancelLoading)
                        ? {
                            name: "leadingIcon",
                            fn: _withCtx(() => [
                              _createVNode(_component_AppLoader, { size: "xxs" })
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["disabled"]),
                    _createVNode(_component_AppButton, {
                      type: _ctx.buttonType,
                      disabled: _ctx.confirmLoading || _ctx.cancelLoading,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close(true)))
                    }, _createSlots({
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.confirmButtonText), 1)
                      ]),
                      _: 2
                    }, [
                      (_ctx.confirmLoading)
                        ? {
                            name: "leadingIcon",
                            fn: _withCtx(() => [
                              _createVNode(_component_AppLoader, {
                                type: "secondary",
                                size: "xxs"
                              })
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["type", "disabled"])
                  ])
                ])
              ]),
              _: 1
            })
          ], 512)
        ]),
        _: 1
      }, 8, ["initial-focus"])
    ]),
    _: 1
  }, 8, ["show"]))
}